import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SessionService } from './session.service';
import { Subject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

/**
 * CommonService provides parity with legacy `common.SessionMemory.API` usage.
 * Exposes `SessionMemory.API.Get/Post/Clear` and convenience access to stored items.
 */
@Injectable({ providedIn: 'root' })
export class CommonService {

  private userChangeSource = new Subject<any>();

  // 2. Create an Observable that components can subscribe to
  userChange$ = this.userChangeSource.asObservable();

  // 3. Create a method to trigger the change (call this when a user logs in or updates profile)
  notifyUserChange(userData: any) {
    this.userChangeSource.next(userData);
  }
  
  private platformId = inject(PLATFORM_ID);
  private session = inject(SessionService);
  private cookieService = inject(CookieService);

  private get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public SessionMemory = {
    API: {
      Post: (key: string, value: any) => {
        if (!this.isBrowser) return;
        const v = typeof value === 'object' ? JSON.stringify(value) : String(value);
        this.session.post(key, v);
      },
      Get: (key: string) => {
        if (!this.isBrowser) return null;
        return this.session.get(key);
      },
      Clear: () => {
        if (!this.isBrowser) return;
        this.session.clear();
      }
    }
  };
  public LocalMemory = {
    API: {
      Post: (key: string, value: any) => {
        if (!this.isBrowser) return;
        const v = typeof value === 'object' ? JSON.stringify(value) : String(value);
        localStorage.setItem(key, v);
      },
      Get: (key: string) => {
        if (!this.isBrowser) return null;
        return localStorage.getItem(key);
      },
      Clear: () => {
        if (!this.isBrowser) return;
        localStorage.clear();
      }
    }
  };

  // --- COOKIE MEMORY ---
  public CookieMemory = {
    API: {
      Post: (name: string, value: any) => {
        if (!this.isBrowser) return;
        const v = typeof value === 'object' ? JSON.stringify(value) : String(value);
        // Using path '/' ensures the cookie is available across the whole app
        this.cookieService.set(name, v, { path: '/' }); 
      },
      Get: (name: string) => {
        if (!this.isBrowser) return null;
        return this.cookieService.get(name);
      },
      Clear: (name?: string) => {
        if (!this.isBrowser) return;
        if (name) {
          this.cookieService.delete(name, '/');
        } else {
          this.cookieService.deleteAll('/');
        }
      }
    }
  }
 
}
